<template>
    <span>
        <scrollactive class="my-nav">
            <v-navigation-drawer app v-model="drawer" class="grey darken-2" dark disable-resize-watcher width="200">
                <v-list>
                    <v-list-tile><v-list-tile-content><a href="#home" class="scrollactive-item" @click="drawer = false">HOME</a></v-list-tile-content></v-list-tile>
                    <v-divider></v-divider>
                    <template v-for="(item, index) in items">
                        <v-list-tile :key="index"><v-list-tile-content><a :href=item.anchor class="scrollactive-item" @click="drawer = false">{{ item.title }}</a></v-list-tile-content></v-list-tile>
                        <v-divider :key="`divider-${index}`"></v-divider>
                    </template>
                </v-list>
            </v-navigation-drawer>
            <v-toolbar app class="grey darken-2" dark>
                <v-toolbar-side-icon class="hidden-md-and-up" @click="drawer = !drawer" ></v-toolbar-side-icon>
                <v-spacer class="hidden-md-and-up"></v-spacer>
                <v-img src="/images/app-icons/apple-icon.png" max-width="32" max-height="32"></v-img>&nbsp&nbsp
                <a href="#home" class="scrollactive-item no-change" style="font-family:'ZCOOL XiaoWei', serif !important">
                     <v-toolbar-title>  {{ this.$myApp.title }}</v-toolbar-title></a>
                <v-spacer class="hidden-sm-and-down"></v-spacer>

                <template v-for="(item,index) in items">
                     <v-btn :href=item.anchor flat class="scrollactive-item hidden-sm-and-down">{{ item.title }}</v-btn>
                </template>

            </v-toolbar>
        </scrollactive>
    </span>
</template>

<script>
    export default {
        name: 'AppNavigation',
        data() {
            return {
                drawer: false,
                items: [
                    {title: 'Why Us', anchor: '#details'},
                    {title: 'What We Do', anchor: '#services'},
                    {title: 'Contact Us', anchor: '#contact'}
                ]
            };
        }
    };
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css?family=ZCOOL+XiaoWei');
    a {
        color: white;
        text-decoration: none;
    }
    a.is-active:not(.no-change){
        background-color: white;
        color: black!important;
    }
</style>
